<template>
  <div class="card-container-four">
    <div class="title">
      <h1>{{ $t('virtualCardFourModule.title') }}</h1>
    </div>
    <div class="feature-item" v-for="(feature, index) in $t('virtualCardFourModule.privacyAndSecurityList')" :key="index">
      <img :src="feature.img" alt="UBPay" class="item-img"/>
      <div class="feature-content">
        <div class="feature-title">{{ feature.title }}</div>
        <div class="feature-detail">{{ feature.content }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="less">
.card-container-four {
  min-height: 500px;
  background-image: url('~@/assets/imgs/home/psbg.png');
  background-size: cover;
  padding-left: 100px;
  padding-top: 30px;
  .title {
    font-size: 28px;
    padding: 20px 0;
  }
  .feature-item {
    margin-bottom: 30px;
  }
  .item-img {
    width: 20px;
  }
  .feature-title {
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
